



























import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class HiveConfDetail extends Vue {
  @Prop() hiveConf!: any;
}
